/**
 * Znacznik ostatniej aktywności użytkownika, na którym stoi auto-wylogowanie po
 * bezczynności (`useIdleLogout`).
 *
 * Siedzi w localStorage, a nie w pamięci: aktywność w dowolnej zakładce liczy się do
 * wszystkich, a sesja porzucona na noc zostaje wykryta przy następnym starcie aplikacji.
 * Klucz zawiera 'auth', więc czyszczenie localStorage przy wylogowaniu usuwa go razem
 * z resztą danych sesji.
 *
 * Zapis żyje w osobnym pliku, bo dotyka go i hook, i `userState` (świeże logowanie
 * zeruje licznik). Import hooka w stanie zrobiłby cykl.
 */
const LAST_ACTIVITY_KEY = 'auth.lastActivity';

export const readLastActivity = (): number => {
  try {
    const raw = localStorage.getItem(LAST_ACTIVITY_KEY);
    const ts = raw ? Number(raw) : NaN;
    return Number.isFinite(ts) ? ts : 0;
  } catch {
    return 0;
  }
};

export const writeLastActivity = (ts: number): void => {
  try {
    localStorage.setItem(LAST_ACTIVITY_KEY, String(ts));
  } catch {
    /* ignore quota */
  }
};

/**
 * Licznik bezczynności startuje OD NOWA po każdym udanym logowaniu.
 *
 * Bez tego zostawał znacznik z poprzedniej sesji (zamknięta karta nie woła `logout`,
 * więc nikt go nie kasował). Po zalogowaniu następnego dnia pierwsze sprawdzenie
 * widziało kilkanaście godzin bezczynności i natychmiast wylogowywało — użytkownik
 * musiał logować się dwa razy, bo dopiero to wylogowanie czyściło klucz.
 */
export const markActivityNow = (): void => writeLastActivity(Date.now());
